import { useQuery } from "@tanstack/react-query";
import { startQuiz } from "@/services/apiQuiz";

export function useStartQuiz({ courseId, lectureId, quizId }) {
  const {
    isPending,
    data: quiz,
    isSuccess,
  } = useQuery({
    queryKey: ["StartQuiz", courseId, lectureId, quizId],
    queryFn: () => startQuiz({ courseId, lectureId, quizId }),
    retry: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return { isPending, quiz, isSuccess };
}
